import { useSidebarStore } from '../../../../../store';

export function useInboxSectionAccordion() {
  const isAccordionOpen = useSidebarStore((s) => s.isInboxSectionOpen);
  const onToggleAccordion = useSidebarStore((s) => s.toggleInboxSection);

  return { isAccordionOpen, onToggleAccordion };
}
